var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" + _vm.msgType + "_" + _vm.entitiesType
        ),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", sm: "3", md: "2", xl: "2" },
                    },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", sm: "3", md: "2", xl: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          attrs: { disabled: _vm.activateSpinner },
                          on: {
                            click: function ($event) {
                              return _vm.onRefresh()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-rotate-right fs-14px",
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-tabs",
                {
                  staticClass: "p-3 w-100",
                  attrs: { "content-class": "mt-3", "nav-class": "d-none" },
                  model: {
                    value: _vm.tabIndex,
                    callback: function ($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex",
                  },
                },
                [
                  _c(
                    "b-tab",
                    { attrs: { title: "S3" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _vm.activateSpinner
                            ? _c("spinner")
                            : _c(
                                "div",
                                [
                                  _vm.S3ConfigList.length > 0
                                    ? _c("b-table", {
                                        staticClass: "mt-3 table-striped",
                                        attrs: {
                                          hover: "",
                                          responsive: "",
                                          items: _vm.S3ConfigList,
                                          fields: _vm.S3ConfigFields,
                                          selectable: "",
                                          "select-mode": "single",
                                        },
                                        on: {
                                          "row-selected":
                                            _vm.seeS3ConfigDetails,
                                        },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "noResult" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("common.no_result")
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }